import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js';

import './style.scss';

const moduleSelector = '.eiovisual-accordion-row-start';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo accordion row start');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
       
    }

    // _________________________________________________________________________

    /**
     * Sostituisce gli elementi .fit-text con elementi fit-text
     * @returns {undefined}
     */
    task1() {
        // definisce il target
        // let $target = this.$module.querySelector('.target');
    }

    // _________________________________________________________________________

}

// export
export default new Module();